import { render, staticRenderFns } from "./ProfesorReagendar.vue?vue&type=template&id=343e8c93&"
import script from "./ProfesorReagendar.vue?vue&type=script&lang=js&"
export * from "./ProfesorReagendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports